import { City } from './geolite'
import { Image } from './image'
import { VideoOrientation } from './widget/video'

export enum BlockCode {
  ARTICLE_SCROLL = 'article-scroll',
  VIDEO_SCROLL = 'video-scroll',
  VIDEO_DRAGGING = 'video-dragging',
  RANDOMIZER = 'randomizer',
  VIDEO = 'video',
  VIDEO_FIXED = 'video-fixed',
  HOME = 'home',
  AWARDS_FIXED = 'video-awards',
}

export enum BlockArticleCountingType {
  VIEWS = 1,
  UNIQUE = 2,
}

export enum GenderSlug {
  ALL = 'all',
  FEMALE = 'female',
  MALE = 'male',
}

export type GeoAllCities = 'all_cities'

export enum GeoSlugCountry {
  ALL = 'all',
  NOT_RUSSIA = 'not_russia',
  ONLY_RUSSIA = 'russia',
}

export enum IncomeSlug {
  LESS_AVERAGE = 'lessAverage',
  AVERAGE = 'average',
  MORE_AVERAGE = 'moreAverage',
}

export enum OSSlug {
  MACOS = 'macos',
  WINDOWS = 'windows',
  IOS = 'ios',
  ANDROID = 'android',
}

export interface BlockArticleTargetings {
  sections: {
    id: number
    name: string
    code: string
  }[]
  geo: {
    country: GeoSlugCountry
    city: GeoAllCities | City[]
  }
  gender: GenderSlug
  age: number | number[] | null
  income: IncomeSlug | IncomeSlug[] | null
  os: OSSlug[]
  tags?: {
    id: number
    name: string
    code: string
  }[]
}

export interface BlockArticle {
  id: number
  block_id: number
  article_id: number
  views: number
  days_limit: number
  stat_views: number
  counting_type: BlockArticleCountingType
  distribute_to_date: string
  days_limit_count: number
  position: number
  sort: number
  type: number
  targetings: BlockArticleTargetings
  article: {
    id: number
    active: number
    name: string
    code: string
    type: number
    active_from: string
    preview_text: null | string
    production_id: number
    detailImage: Image
    section: {
      parent: {
        id: number
        active: number
        name: string
        code: string
      }
      id: number
      active: number
      name: string
      code: string
    }
    videos?: {
      orientation: VideoOrientation
    }[]
  }
}

export type ShortBlockArticle = Pick<
  BlockArticle,
  | 'id'
  | 'stat_views'
  | 'views'
  | 'article_id'
  | 'days_limit'
  | 'days_limit_count'
  | 'block_id'
  | 'distribute_to_date'
  | 'targetings'
  | 'counting_type'
> & {
  article?: { id: number; name: string; code?: string }
  pixel_code: string
  video_views?: number | null
  video_id?: number | null
}

export interface Block {
  id: number
  title: string
  type: number
}

export interface BlockWithoutPositions extends Block {
  code: Exclude<BlockCode, BlockCode.VIDEO_DRAGGING>
  blockArticles: BlockArticle[]
}

export type BlockWithPositions = Block &
  (
    | {
        code: BlockCode.VIDEO_DRAGGING | BlockCode.VIDEO_FIXED
        type: number
        blockArticles: {
          position: number
          blockArticles: {
            error?: BlockArticle[]
            horizontal?: BlockArticle[]
            vertical?: BlockArticle[]
          }
        }[]
      }
    | {
        code: BlockCode.AWARDS_FIXED
        type: number
        blockArticles: {
          position: number
          blockArticles: BlockArticle[]
        }[]
      }
  )
